import {BaseViewModel} from '../../../../../models/base/base-view-model';
import {Injectable} from '@angular/core';
import {GuidesDomainModel} from '../../../domain/guides-domain-model';

@Injectable()
export class GuideCardViewModel extends BaseViewModel {

  constructor(
    private dm: GuidesDomainModel,
  ) {
    super();
  }

}
